import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, Badge } from 'antd';

import ClockIcon from '@/assets/icons/clock.svg?react';
import NotificationsIcon from '@/assets/icons/notifications.svg?react';

const Notifications = () => {
  const [t] = useTranslation();

  const onItemClick = () => {
    console.log('click on notification');
  };

  const items = [
    {
        key: "title",
        label: <div className="notifications__title">{t("notifications")}</div>,
        disabled: true,
    },
    ...notificationsList.map((item) => ({
        key: item._id,
        label: (
            <div className="notifications__item">
                <ClockIcon className="notifications__item-icon" />
                <span className="notifications__item-text">
        The task{" "}
                    <span style={{ color: "#69c262" }}>{item.name}</span> expires today
        in 12:20 AM.
      </span>
            </div>
        ),
        onClick: () => onItemClick(),
    })),
  ];

  return (
    <Dropdown trigger={['click']} menu={{ items }}>
      <Badge
        dot={!!notificationsList.length}
        color={notificationsList.length ? '#69C262' : null}
        offset={[-8, 5]}
        size="default"
      >
        <NotificationsIcon onClick={() => console.log('notification icon')} />
      </Badge>
    </Dropdown>
  );
};

const notificationsList = [
  {
    _id: '1',
    name: '#Landing page',
  },
  {
    _id: '2',
    name: '#Landing page',
  },
];

export default Notifications;
